// Action Types
export const FETCH_REVENUE_ANALYSIS_REQUEST = "FETCH_REVENUE_ANALYSIS_REQUEST";
export const FETCH_REVENUE_ANALYSIS_SUCCESS = "FETCH_REVENUE_ANALYSIS_SUCCESS";
export const FETCH_REVENUE_ANALYSIS_FAILURE = "FETCH_REVENUE_ANALYSIS_FAILURE";

// Action Creators
export const fetchRevenueAnalysisRequest = (params) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_REVENUE_ANALYSIS_REQUEST,
      payload: params,
    });
  };
};
export const fetchRevenueAnalysisSuccess = (data) => ({
  type: FETCH_REVENUE_ANALYSIS_SUCCESS,
  payload: data,
});
export const fetchRevenueAnalysisFailure = (error) => ({
  type: FETCH_REVENUE_ANALYSIS_FAILURE,
  payload: error,
});
